"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.emit = void 0;
var emit = function emit(ctx, name) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  ctx.dispatchEvent(new CustomEvent(name, {
    detail: data
  }));
};
exports.emit = emit;
